import { gql } from "@apollo/client";

const GET_ALL_REQUIREMENTS = gql`
  query GET_ALL_REQUIREMENTS {
    allRequirements: getRequirements {
      _id
      name
      description
      instructions
      expiryType
      visibleToHCF
      visibleToHCP
      stateSpecific
      disableWorkerUpload
      checklist {
        enabled
        description
        items
      }
    }
  }
`;

export { GET_ALL_REQUIREMENTS };
